<template>
    <layout :showuserinfo="false" title="Daftar Pengecualian" :crumbs="crumbs">
       <w-button class="mb3" text @click="kembali()">
            &#60;&#60; Kembali
        </w-button>
        <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">mdi mdi-tune</w-icon>
                Carian Hak Milik
            </template>
            <w-flex class="justify-end">
                <div class="xs4 mr3">
                    <w-select
                        class="mb3"
                        :items="districts"
                        v-model="form.kod_daerah"
                        outline
                        label="Pilih Daerah"
                        label-position="left"
                        @input="fetchData1()"
                    >
                    </w-select>
                </div>
            </w-flex>
            <w-form @submit.prevent="submit">
                <w-flex class="mt3">
                    <div class="xs2">
                        <w-radio
                            class="mr2"
                            v-model="form.form_option"
                            name="radio"
                            return-value="option1"
                        >
                            Barcode
                        </w-radio>
                    </div>
                    <div class="xs10 mr3">
                        <w-input
                            v-model="form.barcode"
                            placeholder="Sila Masukkan Barcode"
                            :disabled="form.form_option !== 'option1'"
                            :validators="[validators.required]"
                            maxlength="30"
                        ></w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs2 mr3">
                        <w-radio
                            v-model="form.form_option"
                            name="radio"
                            return-value="option2"
                        >
                            ID Hakmilik
                        </w-radio>
                    </div>
                    <div class="xs3 mr3">
                        <w-select
                            :validators="[validators.required]"
                            placeholder="Sila Pilih Kod Mukim"
                            v-model="form.kod_mukim"
                            :items="mukim"
                            value="01"
                            :disabled="form.form_option !== 'option2'"
                        />
                    </div>
                    <div class="xs3 mr3">
                        <w-select
                            :validators="[validators.required]"
                            placeholder="Sila Pilih Jenis Hakmilik"
                            v-model="form.kod_jenis_hm"
                            :items="jhm"
                            :disabled="form.form_option !== 'option2'"
                        />
                    </div>
                    <div class="xs4 mr3">
                        <w-input
                            v-model="form.no_hm"
                            :model-value="
                                form.form_option !== 'option2' ? '' : form.no_hm
                            "
                            placeholder="Sila Masukkan No. Hakmilik"
                            :disabled="form.form_option !== 'option2'"
                            :validators="[
                                form.form_option === 'option2'
                                    ? validators.required
                                    : null,
                            ]"
                        >
                        </w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_bangunan"
                            :model-value="
                                form.form_option !== 'option2'
                                    ? ''
                                    : form.no_bangunan
                            "
                            placeholder="Bangunan"
                            :disabled="form.form_option !== 'option2'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_tingkat"
                            :model-value="
                                form.form_option !== 'option2'
                                    ? ''
                                    : form.no_tingkat
                            "
                            placeholder="Tingkat"
                            :disabled="form.form_option !== 'option2'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_petak"
                            :model-value="
                                form.form_option !== 'option2'
                                    ? ''
                                    : form.no_petak
                            "
                            placeholder="Petak"
                            :disabled="form.form_option !== 'option2'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3"></div>
                </w-flex>

                <w-flex class="mt3">
                    <div class="xs2 mr3">
                        <w-radio
                            v-model="form.form_option"
                            name="radio"
                            return-value="option3"
                        >
                            Mukim dan No. Hakmilik
                        </w-radio>
                    </div>
                    <div class="xs5 mr3">
                        <w-select
                            :validators="[
                                form.form_option === 'option3'
                                    ? validators.required
                                    : null,
                            ]"
                            placeholder="Sila Pilih Kod Mukim"
                            v-model="form.kod_mukim"
                            :model-value="
                                form.form_option !== 'option3'
                                    ? ''
                                    : form.kod_mukim
                            "
                            :items="mukim"
                            :disabled="form.form_option !== 'option3'"
                        />
                    </div>
                    <div class="xs5 mr3">
                        <w-input
                            :validators="[
                                form.form_option === 'option3'
                                    ? validators.required
                                    : null,
                            ]"
                            v-model="form.no_hm"
                            :model-value="
                                form.form_option !== 'option3' ? '' : form.no_hm
                            "
                            placeholder="Sila Masukkan No. Hakmilik"
                            :disabled="form.form_option !== 'option3'"
                        >
                        </w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_bangunan"
                            :model-value="
                                form.form_option !== 'option3'
                                    ? ''
                                    : form.no_bangunan
                            "
                            placeholder="Bangunan"
                            :disabled="form.form_option !== 'option3'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_tingkat"
                            :model-value="
                                form.form_option !== 'option3'
                                    ? ''
                                    : form.no_tingkat
                            "
                            placeholder="Tingkat"
                            :disabled="form.form_option !== 'option3'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_petak"
                            :model-value="
                                form.form_option !== 'option3'
                                    ? ''
                                    : form.no_petak
                            "
                            placeholder="Petak"
                            :disabled="form.form_option !== 'option3'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3"></div>
                </w-flex>

                <w-flex class="mt3">
                    <div class="xs2 mr3">
                        <w-radio
                            v-model="form.form_option"
                            name="radio"
                            return-value="option4"
                        >
                            Jenis dan No. Hakmilik
                        </w-radio>
                    </div>
                    <div class="xs5 mr3">
                        <w-select
                            :validators="[
                                form.form_option === 'option4'
                                    ? validators.required
                                    : null,
                            ]"
                            placeholder="Sila Pilih Jenis Hakmilik"
                            v-model="form.kod_jenis_hm"
                            :model-value="
                                form.form_option !== 'option4'
                                    ? ''
                                    : form.kod_jenis_hm
                            "
                            :items="jhm"
                            :disabled="form.form_option !== 'option4'"
                        />
                    </div>
                    <div class="xs5 mr3">
                        <w-input
                            :validators="[
                                form.form_option === 'option4'
                                    ? validators.required
                                    : null,
                            ]"
                            v-model="form.no_hm"
                            :model-value="
                                form.form_option !== 'option4' ? '' : form.no_hm
                            "
                            placeholder="Sila Masukkan No. Hakmilik"
                            :disabled="form.form_option !== 'option4'"
                        >
                        </w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_bangunan"
                            :model-value="
                                form.form_option !== 'option4'
                                    ? ''
                                    : form.no_bangunan
                            "
                            placeholder="Bangunan"
                            :disabled="form.form_option !== 'option4'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_tingkat"
                            :model-value="
                                form.form_option !== 'option4'
                                    ? ''
                                    : form.no_tingkat
                            "
                            placeholder="Tingkat"
                            :disabled="form.form_option !== 'option4'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3">
                        <w-input
                            v-model="form.no_petak"
                            :model-value="
                                form.form_option !== 'option4'
                                    ? ''
                                    : form.no_tingkat
                            "
                            placeholder="Petak"
                            :disabled="form.form_option !== 'option4'"
                        >
                        </w-input>
                    </div>
                    <div class="xs2 mr3"></div>
                    <div class="xs2 mr3"></div>
                </w-flex>
                <div class="d-flex justify-end mt3">
                    <w-button
                        class="my1 mr0"
                        type="submit"
                        :loading="searching"
                    >
                        Semak Cukai
                    </w-button>
                </div>
            </w-form>
        </w-dialog>
        <center>
            <h4 v-if="hasSearched && !no_hm" class="ma1">
                Tiada Rekod Ditemui
            </h4>
        </center>
        <z-page
            title="Daftar Pengecualian"
            :append-button="true"
            icon="fal fa-database"
        >
            <w-form @submit.prevent="daftarPengecualian">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-tooltip color="primary">
                            <template #activator="{ on }">
                                <w-badge
                                    style="width: 20%"
                                    class="mr10"
                                    round
                                    top
                                    right
                                    xs
                                >
                                    <template #badge>
                                        <w-icon
                                            v-on="on"
                                            @click="dialog.show = true"
                                            >wi-plus</w-icon
                                        >
                                        <!-- <w-button
                      @click="showAlert = !showAlert"
                      icon="wi-plus"
                      bg-color="primary"
                      sm
                    >
                    </w-button> -->
                                    </template>
                                    <label style="color: grey"
                                        >No Hak Milik</label
                                    >
                                </w-badge>
                            </template>
                            Klik Untuk Carian Hak Milik
                        </w-tooltip>
                        <w-input
                            v-model="no_hm"
                            :validators="[validators.required]"
                            disabled
                            style="color: blue; width: 100%"
                        >
                        </w-input>
                    </div>

                    <div class="xs6 mr3">
                        <w-tooltip color="primary">
                            <template #activator="{ on }">
                                <w-badge
                                    style="width: 20%"
                                    class="mr10"
                                    round
                                    top
                                    right
                                >
                                    <template #badge>
                                        <w-icon v-on="on">
                                            fal fa-info-circle</w-icon
                                        >
                                    </template>
                                    <label style="color: grey">No Akaun</label>
                                </w-badge>
                            </template>
                            Tidak Boleh Diubah
                        </w-tooltip>

                        <w-input
                            :validators="[validators.required]"
                            :placeholder="[[hmAkaun]]"
                            disabled
                            style="color: blue; width: 100%"
                        >
                        </w-input>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            placeholder="Sila Masukkan No. MMK"
                            outline
                            tile
                            :validators="[validators.required]"
                            v-model="daftar.no_mknk"
                            >No. MKNK
                        </w-input>
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            type="date"
                            :validators="[validators.required]"
                            v-model="daftar.tarikh_mula"
                            outline
                            tile >Tarikh Mula</w-input>
                    </div>

                </w-flex>

                <div class="d-flex justify-end mt3">
                    <w-button class="my1 mr0" type="submit"
                        >Daftar Pengecualian</w-button
                    >
                </div>
            </w-form>
        </z-page>
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import { Inertia } from "@inertiajs/inertia";

export default {
    extends: ZResource,
    components: {},
    props: {},
    data() {
        return {
            validators: {
                required: (value) => !!value || "Sila Isi Ruangan Ini",
                // Other validators...
            },
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                {
                    label: "Daftar Pengecualian",
                    route: "/cukai-tanah/daftarPengecualian",
                },
            ],

            districts: [{ label: "Loading", selected: true }],
            mukim: [{ label: "Loading", selected: true }],
            jhm: [{ label: "Loading", selected: true }],
            daftar: {
                keluasan: null,
                hm_akaun_id: null,
                no_mknk: null,
                tarikh_mula: null,
                status: 1,
            },
            form: {
                kod_daerah: "01",
                form_option: "option1",
                kategori_carian: "1",
                barcode: null,
                kod_mukim: "01",
                kod_jenis_hm: null,
                no_hm: "",
                no_bangunan: null,
                no_tingkat: null,
                no_petak: null,
                no_resit: null,
                no_kp: null,
            },
            search: {
                keyword: "",
                is_cukai_tanah: "",
            },
            searching: false,
            hasSearched: false,
            no_hm: null,
            hmAkaun: null,
            dialog: {
                show: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 1000,
            },
        };
    },
    setup() {},
    methods: {
           kembali() {
            window.history.back();
        },
        async daftarPengecualian() {
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/pengecualian`,
                responseType: "json",
                data: this.daftar,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        Inertia.get("/cukai-tanah/showPengecualian");
                    }
                }).catch(err => {
             this.$waveui.notify({
                error: true,
                message: "Ralat",
                timeout: 3000,
              });
              return;
                    })
                .finally((e) => {
                    // Inertia.get("/cukai-tanah/showPengecualian");
                });
        },
        async submit() {
            if (this.form.barcode != null || this.form.no_hm != null) {
                this.cukai = [];
                this.hasSearched = false;
                this.searching = true;

                await axios({
                    method: "post",
                    url: `${this.apiBaseUrl}/cukai/cari`,
                    responseType: "json",
                    data: this.form,
                })
                    .then((e) => {
                        if (e.data.length > 0) {
                            // console.log(e.data[0]);
                            this.no_hm = e.data[0].no_hm;
                            this.hmAkaun = e.data[0].no_akaun;
                            this.daftar.keluasan = e.data[0].keluasan;
                            this.daftar.hm_akaun_id = e.data[0].id;
                            this.dialog.show = false;
                        }
                    })
                    .finally((e) => {
                        (this.dialog.show = false), (this.searching = false);
                        this.hasSearched = true;
                    });
            } else {
                console.log("no data");
            }
        },
        focusTab(e) {
            this.form.kategori_carian = e.id;
        },

        async fetchData() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah`,
                responseType: "json",
            }).then((e) => {
                this.districts = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
                this.form.kod_daerah = this.districts[0].value;
            });
        },

        async fetchData2() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/jenisHm`,
                responseType: "json",
            }).then((e) => {
                this.jhm = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },
        async fetchData1(w) {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/daerah/${this.form.kod_daerah}/mukim`,
                responseType: "json",
            }).then((e) => {
                this.mukim = e.data.map((d) => {
                    return {
                        label: d.kod + " - " + d.keterangan,
                        value: d.kod,
                    };
                });
            });
        },

        async init() {
            const res = await this.fetchData();
            const res1 = await this.fetchData1();
            const res2 = await this.fetchData2();
        },
    },

    mounted() {
        this.init();
    },
};
</script>
<style>
div.w-menu.w-select__menu.w-menu--bottom.w-menu--align-left {
    z-index: 500;
}
</style>
